<template>
  <div>
    <div class="promos">
      <div v-for="(promo, index) in promos.items" :key="index" class="promo">
        <div class="promo__pic">
          <img :src="promo.imageUrl"/>
        </div>
        <div class="promo__content">
          <div class="promo__content-header">
            <div class="promo__date">{{ $formatDateLong(promo.publicationDate) }}</div>
            <div class="promo__pinned" v-if="promo.isPinned">
              <svg-icon icon="pin" height="16" width="16" view-box="0 0 16 16"/>
            </div>
          </div>
          <div class="promo__title">{{ promo.title }}</div>
          <div class="promo__description">{{ promo.summary }}</div>
          <div class="promo__more">
            <a :href="promo.url">
              <span>{{ $res.General.ShowMore }}</span>
              <svg-icon icon="straight-arrows/right"/>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="promos__footer">
      <div class="promo__more">
        <a :href="promos.allPromosUrl" target="_blank">
          <span>{{ $res.General.AllPromo }}</span>
          <svg-icon icon="straight-arrows/right"/>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import SvgIcon from '@/common/controls/SvgIconControl.vue';

export default {
  components: {
    SvgIcon
  },
  props: {
    promos: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>


.promos {
  padding: 0 16px;
  background-color: var(--white);
  border-radius: var(--border-radius-lg);
  box-shadow: var(--shadow);
}

.promo {
  display: flex;
  padding: 20px 0;
  
  + .promo {
    border-top: 2px solid var(--main-50);
  }
}

.promo__pic {
  height: 170px;
  min-width: 456px;
  border-radius: var(--border-radius-lg);
  background-color: #3a87ad;
  overflow: hidden;

  > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: inline-block;
    position: relative;

    // browser show ::pseudo elements for broken image, so
    &::before {
      content: "";
      position: absolute;
      display: block;
      inset: 0;
      background: var(--main-50);
    }
  }
}

.promo__content {
  flex-grow: 1;
  padding-inline-start: 24px;
}

.promo__date {
  font-size: 13px;
  line-height: 20px;
  color: var(--second-20);
}

.promo__content-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
}

.promo__title {
  text-transform: uppercase;
  margin-bottom: 10px;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #333E48;
}

.promo__description {
  margin-bottom: 20px;
  line-height: 24px;
  font-size: 16px;
}

.promo__more {
  line-height: 24px;
  
  a {
    display: inline-block;
    padding: 3px 0;
    font-size: 16px;
    border-bottom: 1px solid transparent;
    color: var(--main-10);

    svg {
      margin-inline-start: 4px;
      position: relative;
      top: -1px;
    }

    &:hover {
      border-bottom-color: currentColor;
    }
  }
}

.promo__pinned {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px 10px;
  background: var(--blue-200);
  border-radius: 4px;
}

.promos__footer {
  display: flex;
  flex-flow: row nowrap;
  justify-content: end;
  margin-top: 16px;
}
</style>



